type ToastType = "success" | "error";

const TOAST_CONTAINER_ID = "app-toast-container";
let stylesMounted = false;

function mountStyles() {
    if (stylesMounted || typeof document === "undefined") {
        return;
    }

    const style = document.createElement("style");
    style.setAttribute("data-toast-styles", "true");
    style.innerHTML = `
    #${TOAST_CONTAINER_ID} {
      position: fixed;
      top: 16px;
      right: 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      z-index: 9999;
      pointer-events: none;
      width: min(360px, calc(100vw - 32px));
    }

    .app-toast {
      pointer-events: auto;
      border-radius: 10px;
      color: #ffffff;
      font-weight: 600;
      font-size: 14px;
      line-height: 1.4;
      padding: 12px 14px;
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
      animation: app-toast-in 180ms ease-out;
    }

    .app-toast-success {
      background: #1c8f48;
    }

    .app-toast-error {
      background: #c0392b;
    }

    @keyframes app-toast-in {
      from {
        opacity: 0;
        transform: translateY(-6px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `;

    document.head.appendChild(style);
    stylesMounted = true;
}

function getContainer() {
    if (typeof document === "undefined") {
        return null;
    }

    let container = document.getElementById(TOAST_CONTAINER_ID);

    if (!container) {
        container = document.createElement("div");
        container.id = TOAST_CONTAINER_ID;
        document.body.appendChild(container);
    }

    return container;
}

function showToast(type: ToastType, message: string) {
    if (typeof document === "undefined") {
        return;
    }

    mountStyles();
    const container = getContainer();

    if (!container) {
        return;
    }

    const toast = document.createElement("div");
    toast.className = `app-toast app-toast-${type}`;
    toast.textContent = message;

    container.appendChild(toast);

    window.setTimeout(() => {
        toast.remove();
    }, 3200);
}

export function showSuccessToast(message: string) {
    showToast("success", message);
}

export function showErrorToast(message: string) {
    showToast("error", message);
}
